exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".contractContainer-6507b .title-7d01e{margin-bottom:12px;font-size:20px;font-weight:600;line-height:28px;color:#262626}", ""]);

// Exports
exports.locals = {
	"contractContainer": "contractContainer-6507b",
	"title": "title-7d01e"
};